import { IconButton } from "@material-ui/core";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RefreshIcon from "@mui/icons-material/Refresh";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  FormGroup,
  FormLabel,
  Grid,
  InputAdornment,
  Stack,
  styled,
  Switch,
  Tab,
  Tooltip,
  Typography,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import jwt_decode from "jwt-decode";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import "../../App.css";
import copyIcon from "../../assets/USA_Images/copyIcon.svg";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import CreateIssueTypeDialog from "../../components/DialogBoxComponent/CreateIssueTypeDialog";
import KeyValidityDialog from "../../components/DialogBoxComponent/KeyValidityDialog";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import Toast from "../../components/ToastContainer/CustomToast";
import {
  getListSettings,
  updateSettings,
} from "../../slices/AdditionalSettings/AdditionalSettingsSlice";
import {
  generateAPIKey,
  getAPIKeys,
} from "../../slices/Integrations/IntegrationSlice";
import {
  filterPropertyMgmt,
  getIssuestypes,
  propertyList,
  validateCredentials,
} from "../../slices/PrismIntegration/PrismIntegrationSlice";
import { customerSubscription } from "../../slices/Subscription/SubscriptionSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";

const Android12Switch = styled(Switch)(({ mode, theme }) => ({
  padding: 8,
  "&.MuiSwitch-root": {
    marginTop: "-8px",
  },
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    border: "1px solid #888B8D",
    backgroundColor: mode ? "#888B8D" : "white",
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#888B8D",
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
    position: "relative",
    "&:before": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
  },
  "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
    backgroundColor: "#fff", // Change thumb color when checked
    "&:after": {
      content: '""',
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "60%",
      height: "60%",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="5.97" viewBox="0 0 8 5.97"><path fill="%23226BAB" d="M17.772,14.911l-3.381,3.381-1.353-1.352a.956.956,0,0,0-1.352,1.352l2.03,2.029a.955.955,0,0,0,1.352,0l4.057-4.057a.956.956,0,1,0-1.352-1.352Z" transform="translate(-11.405 -14.63)"/></svg>')`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "contain",
    },
  },
  "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#226BAB !important",
    opacity: 1,
  },
}));

function Integration() {
  var decoded_jwtToken = jwt_decode(
    localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN)
  );
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [totalRecords, setTotalRecords] = useState(1);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(0);
  const [dateFormat, setDateFormat] = useState("");
  const [noteable, setNoteable] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [value, setValue] = React.useState("");
  const [workOrderEnabled, setWorkOrderEnabled] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [propertyManagement, setPropertyManagement] = useState([]);
  const [properties, setProperties] = useState([]);
  const [issueTypes, setIssueTypes] = useState([]);
  const [addIssueType, setAddIssueType] = useState(false);
  const [propertyManagementId, setPropertyManagementId] = useState("");
  const [selectPropertyManagement, setSelectedPropertyManagement] = useState(
    null
  );
  const [propertId, setPropertId] = useState(null);
  const [issueTypeId, setIssueTypeId] = useState(null);
  const [issueTypeSelected, setIssueTypeSelected] = useState(null);
  const [companySettings, setCompanySettings] = useState({});
  const [initialSetUp, setInitialSetUp] = useState(false);
  const [propertyManagementexist, setPropertyManagementExist] = useState(false);
  const [propertyExist, setPropertyExist] = useState();
  const [issueTypeExist, setIssueTypeExist] = useState();
  const [prismFeature, setPrismFeature] = useState(false);
  const [featureList, setFeatureList] = useState([]);
  const fiveStarString = "*****";

  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);

  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 50,
  });

  const renderCellScheduledValidFrom = (date) => (params) => {
    const formattedDate = moment(
      CommonUtil.getLocalDateTimeInYearFormat(params.row.validFrom)
    ).format(
      date === "dd-MM-yyyy"
        ? "DD-MM-YYYY"
        : date === "MM-dd-yyyy"
          ? "MM-DD-YYYY"
          : date === "yyyy-MM-dd"
            ? "YYYY-MM-DD"
            : ""
    );
    return <span className="table-cell-trucate">{formattedDate}</span>;
  };

  const renderCellScheduledValidTo = (date) => (params) => {
    if (params.row.validTo !== undefined && params.row.validTo !== null) {
      const formattedDate = moment(
        CommonUtil.getLocalDateTimeInYearFormat(params.row.validTo)
      ).format(
        date === "dd-MM-yyyy"
          ? "DD-MM-YYYY"
          : date === "MM-dd-yyyy"
            ? "MM-DD-YYYY"
            : date === "yyyy-MM-dd"
              ? "YYYY-MM-DD"
              : ""
      );
      return <span className="table-cell-trucate">{formattedDate}</span>;
    }
  };

  useEffect(() => {
    let payload = {
      companyId: decoded_jwtToken.companyId,
    };
    if (decoded_jwtToken.companyType === "CUSTOMER") {
      dispatch(customerSubscription(payload))
        .unwrap()
        .then((res) => {
          if (res.code === "MSGS4032" && res.data) {
            const featureNames = res.data.data.feature.map(
              (feature) => feature.name
            );
            setFeatureList(featureNames);
          }
        });
    }
  }, []);

  useEffect(() => {
    const normalizedFeatureList = featureList.filter(
      (feature) => feature === "Prism Integration"
    );
    console.log(normalizedFeatureList);

    if (normalizedFeatureList.length !== 0) {
      normalizedFeatureList.forEach((item) => {
        if (item === "Prism Integration") {
          setPrismFeature(true);
          setValue("1");
        }
      });
    } else {
      setPrismFeature(false);
      setValue("2");
    }
  }, [featureList]);

  useEffect(() => {
    loadCompanySettings();
  }, []);

  useEffect(() => {
    const data =
      companySettings.issueTypeId !== ""
        ? companySettings.issueTypeId
        : issueTypeId !== ""
          ? issueTypeId
          : "";
    const issueTypeMatchedId = issueTypes.find(
      (issueType) => issueType.id === data
    );
    if (issueTypeMatchedId?.id) setIssueTypeSelected(issueTypeMatchedId);
  }, [issueTypes]);

  useEffect(() => {
    const propertyManagementIdMatched = propertyManagement.find(
      (propertyMgmt) =>
        propertyMgmt.propertyMgmtId === companySettings.propertyManagementId
    );
    if (propertyManagementIdMatched)
      setSelectedPropertyManagement(propertyManagementIdMatched);
  }, [propertyManagement, companySettings.propertyManagementId]);

  useEffect(() => {
    const propertyMatched = properties.find(
      (property) => property.id === companySettings.propertyId
    );
    if (propertyMatched?.id) setPropertId(propertyMatched);
  }, [properties, companySettings.propertyId]);

  const handleTabsChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleWorkOrderChange = (event) => {
    setWorkOrderEnabled(!workOrderEnabled);
    setCompanySettings({
      ...companySettings,
      prismIntegration: event.target.checked,
    });
  };

  const handleChange = (newPage, size) => {
    setLoading(true);
    setPage(newPage);
    setRowsPerPage(size);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };

  const handleCopy = (content) => {
    navigator.clipboard.writeText(content);
  };

  useEffect(() => {
    loadAPIKeys(paging);
  }, [paging]);

  const handleGenerateKey = () => {
    if (rows.length > 0) {
      setOpenDialog(!openDialog);
      setDiaLogBoxBlur(true);
      return;
    } else {
      generateAPIAccessKey();
    }
  };

  const loadCompanySettings = () => {
    dispatch(getListSettings())
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          setLoading(false);
          setDateFormat(data.data.dateFormat);
          setCompanySettings({...data.data, prismAccessKey:fiveStarString, password:fiveStarString});
          setWorkOrderEnabled(data.data.prismIntegration);
          // if (
          //   CommonUtil.isEmptyString(data.data.userName) ||
          //   CommonUtil.isEmptyString(data.data.password) ||
          //   CommonUtil.isEmptyString(data.data.prismAccessKey)
          // )
            setInitialSetUp(!data.data.prismIntegration);
          if (CommonUtil.isEmptyString(data.data.propertyManagementId))
            setPropertyManagementExist(false);
          else setPropertyManagementExist(true);
          if (CommonUtil.isEmptyString(data.data.propertyId))
            setPropertyExist(false);
          else setPropertyExist(true);
        }
      })
      .catch((er) => { });
  };

  const handleRegenerateKeys = (keyValidity) => {
    generateAPIAccessKey(keyValidity);
    setOpenDialog(!openDialog);
  };

  const generateAPIAccessKey = (keyValidity) => {
    const apiKeyPayload = {
      status: true,
      companyId: localStorage.getItem("companyId"),
      validTill: keyValidity || 7,
    };
    dispatch(generateAPIKey(apiKeyPayload))
      .unwrap()
      .then((data) => {
        if ((data.code = "MSGS4001" && data.data)) {
          Toast(data.message, "success");
          loadAPIKeys(paging);
        }
      })
      .catch((er) => { });
  };

  const loadAPIKeys = () => {
    const payload = {
      pageNumber: paging.page,
      pageSize: paging.rowsPerPage,
      companyId: localStorage.getItem("companyId"),
    };
    dispatch(getAPIKeys(payload))
      .unwrap()
      .then((data) => {
        if (
          data.code === "MSGS4000" &&
          data.data.companyAccessKeys.length > 0
        ) {
          setTotalRecords(data.data.totalCount);
          setRows(data.data.companyAccessKeys);
          setPage(data.data.currentPage);
          setPageSize(data.data.pageSize);
          setTotalPages(data.data.totalPages);
          setNoteable(true);
        } else {
          setRows([]);
        }
        setLoading(false);
      })
      .catch((er) => { });
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 25) {
      return text.substring(0, 25) + "...";
    } else {
      return text;
    }
  };

  const columns = React.useMemo(() => [
    {
      headerName: "",
      sortable: false,
      width: 5,
    },
    {
      field: "accessKey",
      headerName: t("API_KEY"),
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params.row.accessKey,
      renderCell: (params) => (
        <Tooltip title={` ${params.row.accessKey}`} placement="bottom-start">
          <span>{handleTextOverflow(params.row.accessKey)}</span>
        </Tooltip>
      ),
    },
    {
      field: "status",
      headerName: t("API_KEY_STATUS"),
      flex: 1,
      minWidth: 150,
      valueGetter: (params) =>
        params.row.status === true ? "ACTIVE" : "INACTIVE",
    },
    {
      field: "validFrom",
      headerName: t("VALID_FROM"),
      flex: 1,
      width: 150,
      renderCell: renderCellScheduledValidFrom(dateFormat),
    },
    {
      field: "validTo",
      headerName: t("VALID_TO"),
      flex: 1,
      width: 150,
      renderCell: renderCellScheduledValidTo(dateFormat),
    },
    {
      field: "Actions",
      headerName: t("ACTION"),
      type: "actions",
      flex: 1,
      width: 150,
      headerAlign: "center",
      getActions: (params) => [
        <Tooltip title={t("COPY_TOOL_TIP")}>
          <GridActionsCellItem
            icon={<img src={copyIcon} alt="Copy icon" />}
            onClick={() => handleCopy(params.row.accessKey)}
          />
        </Tooltip>,
      ],
    },
  ]);

  const tabsStyle = {
    minWidth: 200,
    textTransform: "none",
  };

  const handleUserNameAndPassword = (event) => {
    setCompanySettings({
      ...companySettings,
      [event.target.name]: event.target.value,
    });
  };

  const handleShowPassword = (event) => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const saveSettings = async () => {
    if (CommonUtil.isEmpty(companySettings.userName)) {
      Toast(t("Username is required"), "error");
      return;
    }
    if (CommonUtil.isEmpty(companySettings.password)) {
      Toast(t("Password is required"), "error");
      return;
    }
    if (CommonUtil.isEmpty(companySettings.prismAccessKey)) {
      Toast(t("prism Access Key is required"), "error");
      return;
    }

    if (CommonUtil.isEmpty(companySettings.propertyId)) {
      Toast(t("Please select property"), "error");
      return;
    }

    if (CommonUtil.isEmpty(companySettings.propertyManagementId)) {
      Toast(t("Please select property management"), "error");
      return;
    }

    if (CommonUtil.isEmpty(companySettings.issueTypeId)) {
      Toast(t("Issue Type is required"), "error");
      return;
    }

    let validation = await validatePrismCredentials();
    if (validation.code === "MSGE4161") {
      Toast(validation.message, "error");
      setLoading(false);
      return;
    }
    const payload = { ...companySettings };
    if (payload.password === "*****") {
      delete payload.password;
    }
    if (payload.prismAccessKey === "*****") {
      delete payload.prismAccessKey;
    }
    
    dispatch(updateSettings(payload))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0071") {
          Toast(data.message, "success");
          // setCompanySettings(data.data);
          setCompanySettings({...data.data, prismAccessKey:fiveStarString, password:fiveStarString});
          loadPropertyManagements(paging, propertyManagementFilter);
        } else if (data.code === "CVAW0064") {
          Toast("Settings already present", "error");
        } else {
          Toast(data.message, "error");
        }
      })
      .catch((er) => { });
  };

  const validatePrismCredentials = async () => {
    const payload = {
      email: companySettings.userName,
      password:  companySettings.password === fiveStarString ? null : companySettings.password,
      prismAccessKey: companySettings.prismAccessKey === fiveStarString? null : companySettings.prismAccessKey,
    };
    const response = dispatch(validateCredentials(payload)).unwrap();
    console.log(response);
    return response;
  };

  const handleSubmit = async () => {
    if (CommonUtil.isEmpty(companySettings.userName)) {
      Toast(t("Username is required"), "error");
      return;
    }
    if (CommonUtil.isEmpty(companySettings.password)) {
      Toast(t("Password is required"), "error");
      return;
    }
    if (CommonUtil.isEmpty(companySettings.prismAccessKey)) {
      Toast(t("prism Access Key is required"), "error");
      return;
    }
    setLoading(true);
    let validation = await validatePrismCredentials();
    if (validation.code === "MSGE4161") {
      Toast(validation.message, "error");
      setLoading(false);
      return;
    }
    dispatch(updateSettings(companySettings))
      .unwrap()
      .then(async (data) => {
        if (data.code === "CVAI0071" || data.code === "CVAW0064") {
          Toast("Details Saved Successfully", "success");
          // setCompanySettings(data.data);
          setCompanySettings({...data.data, prismAccessKey:"*****", password:"*****"});
          await loadPropertyManagements(paging, propertyManagementFilter);
          setInitialSetUp(!initialSetUp);
          setLoading(false);
        } else if (data.code === "CVAW0064") {
          Toast("Settings already present", "error");
        } else {
          Toast(data.message, "error");
        }
      })
      .catch((er) => { });
  };

  const savePropertyManagement = () => {
    if (
      companySettings.propertyManagementId === "" ||
      CommonUtil.isEmptyString(companySettings.propertyManagementId)
    ) {
      Toast("Please Select Property Management", "error");
      return;
    }
    setLoading(true);
    const payload = { ...companySettings };
    if (payload.password === "*****") {
      delete payload.password;
    }
    if (payload.prismAccessKey === "*****") {
      delete payload.prismAccessKey;
    }
    
    dispatch(updateSettings(payload))
      .unwrap()
      .then(async (data) => {
        if (data.code === "CVAI0071" || data.code === "CVAW0064") {
          // setCompanySettings(data.data);
          setCompanySettings({...data.data, prismAccessKey:"*****", password:"*****"});
          Toast("Details Saved Successfully", "success");
          await loadProperties();
          setLoading(false);
          if (
            data.data.propertyManagementId === "" ||
            CommonUtil.isEmptyString(data.data.propertyManagementId)
          )
            setPropertyManagementExist(false);
          else {
            setPropertyManagementExist(true);
          }
        }
      })
      .catch((er) => { });
  };

  const saveProperty = () => {
    if (
      companySettings.propertyId === "" ||
      CommonUtil.isEmptyString(companySettings.propertyId)
    ) {
      Toast("Please Select Property", "error");
      return;
    }
    setLoading(true);
     const payload = { ...companySettings };
    if (payload.password === "*****") {
      delete payload.password;
    }
    if (payload.prismAccessKey === "*****") {
      delete payload.prismAccessKey;
    }
    dispatch(updateSettings(payload))
      .unwrap()
      .then(async (data) => {
        if (data.code === "CVAI0071" || data.code === "CVAW0064") {
          // setCompanySettings(data.data);
          setCompanySettings({...data.data, prismAccessKey:"*****", password:"*****"});
          await loadIssueTypes();
          setLoading(false);
          Toast("Details Saved Successfully", "success");
          if (
            data.data.propertyId === "" ||
            CommonUtil.isEmptyString(data.data.propertyId)
          )
            setPropertyExist(false);
          else {
            setPropertyExist(true);
          }
        }
      })
      .catch((er) => { });
  };

  const [propertyManagementFilter, SetPropertyManagementFilter] = useState({
    name: "",
  });

  useEffect(() => {
    loadPropertyManagements(paging, propertyManagementFilter);
    loadProperties();
    loadIssueTypes(paging, propertyManagementFilter);
  }, []);

  const loadPropertyManagements = (paging, propertyManagementFilter) => {
    return dispatch(
      filterPropertyMgmt(Object.assign(paging, propertyManagementFilter))
    )
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4000" && res.data.propertyManagements) {
          setLoading(false);
          setPropertyManagement(res.data.propertyManagements);
        } else {
          setPropertyManagement([]);
        }
      });
  };

  const loadProperties = () => {
    return dispatch(propertyList())
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4069" && res.data.buildings) {
          setLoading(false);
          setProperties(res.data.buildings);
        } else {
          setProperties([]);
        }
      });
  };

  const loadIssueTypes = () => {
    return dispatch(getIssuestypes())
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4000" && res.data.IssueTypeLists) {
          const flattenedIssueTypes = res.data.IssueTypeLists.flatMap(
            (group) => [
              ...group.children.map((child) => ({
                name: child.name,
                parentId: group.name,
                id: child.id,
              })),
            ]
          );
          setLoading(false);
          setIssueTypes(flattenedIssueTypes);
        } else {
          setIssueTypes([]);
        }
      });
  };

  const handleIssueType = (event, value) => {
    if (value) {
      setIssueTypeSelected(value);
      setCompanySettings({
        ...companySettings,
        issueTypeId: value.id,
        issueTypeName: value.name,
      });
    } else {
      setIssueTypeSelected();
      setCompanySettings({
        ...companySettings,
        issueTypeId: "",
        issueTypeName: "",
      });
    }
  };

  const handleAddIssueType = () => {
    if (CommonUtil.isEmptyString(companySettings.propertyManagementId)) {
      if (CommonUtil.isEmptyString(propertyManagementId)) {
        Toast("Please select Property management", "error");
        return;
      }
    }
    setAddIssueType(!addIssueType);
    setDiaLogBoxBlur(true);
  };

  const handleCallbackData = (callBackData) => {
    loadIssueTypes();
    setIssueTypeId(callBackData.id);
    if (callBackData.id !== null || callBackData.id !== "") {
      setCompanySettings({
        ...companySettings,
        issueTypeId: callBackData.id,
        issueTypeName: callBackData.name,
      });
    }
  };

  return (
    <>
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Grid style={{ display: "flex", cursor: "pointer" }}>
          <Box style={{ margin: "100px, 0" }}>
            <Typography
              variant="h3"
              style={{
                marginLeft: "6px",
                marginRight: "12px",
                color: darkMode ? "#fff" : "#3D4977",
                marginTop: "4px",
              }}
            >
              {t("INTEGRATION")}
            </Typography>
          </Box>
        </Grid>
      </Box>
      <TabContext value={value}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "transparent",
            position: "absolute",
            marginTop: "20px",
            marginLeft: "6px",
          }}
        >
          <TabList
            onChange={handleTabsChange}
            style={{
              borderRadius: "10px",
              backgroundColor: "transparent",
            }}
            indicatorColor="none"
          >
            {prismFeature && (
              <Tab
                label={t("OUTBOUND_CONFIGURATION")}
                value="1"
                className={darkMode ? "tabStyleReg1" : "tabStyleReg"}
                style={tabsStyle}
              />
            )}
            <Tab
              label={t("INBOUND_CONFIGURATION")}
              value="2"
              className={darkMode ? "tabStyleReg1" : "tabStyleReg"}
              style={tabsStyle}
            />
          </TabList>
        </Box>
        {prismFeature && (
          <TabPanel value="1">
            <Grid style={{ marginTop: "70px", marginLeft: "-15px", marginRight: "-18px" }}>
              <FormControl
                component="fieldset"
                variant="standard"
                style={{ width: "100%" }}
              >
                <FormGroup>
                  <Grid
                    style={{
                      display: "flex",
                      marginBottom: "10px",
                    }}
                  >
                    <Grid
                      className={darkMode ? "leftSwitch3" : "leftSwitch1"}
                      style={{
                        borderRadius: "8px",
                      }}
                    >
                      <FormLabel
                        component="legend"
                        className={darkMode ? "formLabel2" : "formLabel"}
                        style={{ fontWeight: "bold" }}
                      >
                        {t("WORK_ORDER_DETAILS")}
                      </FormLabel>
                      <Android12Switch
                        checked={workOrderEnabled}
                        onChange={handleWorkOrderChange}
                        mode={darkMode}
                      />
                    </Grid>
                  </Grid>
                </FormGroup>
              </FormControl>
            </Grid>

            {loading && (
              <Box sx={{ display: "flex" }} className="loader-container">
                <CircularProgress className="loader" />
              </Box>
            )}

            {workOrderEnabled && (
              <Box
                sx={{
                  backgroundColor: darkMode ? "#1B3245" : "#F7F8FA",
                  padding: "10px 10px 10px 10px",
                  marginLeft: "-15px",
                  marginRight: "-18px",
                  borderRadius: "8px !important",
                }}
              >
                <Grid container rowSpacing={2} columnSpacing={1}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <CustomTextfield
                      label={t("USER_NAME")}
                      name="userName"
                      value={
                        companySettings.userName ? companySettings.userName : ""
                      }
                      handleChange={(e) => handleUserNameAndPassword(e)}
                      required={true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <CustomTextfield
                      type={showPassword ? "text" : "password"}
                      label={t("PASSWORD")}
                      name="password"
                      value={
                        companySettings.password ? companySettings.password : ""
                      }
                      required={true}
                      handleChange={(e) => handleUserNameAndPassword(e)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handleShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                              className="PasswordIcon"
                            >
                              {showPassword ? (
                                <Visibility className="visibleIcons" />
                              ) : (
                                <VisibilityOff className="visibleIcons" />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <CustomTextfield
                      label={t("API_KEY_LABEL")}
                      value={companySettings.prismAccessKey}
                      name="prismAccessKey"
                      handleChange={(e) => handleUserNameAndPassword(e)}
                      InputLabelProps={{
                        shrink: companySettings.prismAccessKey ? true : false,
                      }}
                      required={true}
                    />
                  </Grid>
                  {initialSetUp && (
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <SubmitButtons variant="contained" onClick={handleSubmit}>
                        <Typography
                          variant="body1"
                          style={{ textTransform: "none" }}
                        >
                          {t("Submit")}
                        </Typography>
                      </SubmitButtons>
                    </Grid>
                  )}
                  {!initialSetUp && (
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Autocomplete
                        popupIcon={<ExpandMoreIcon />}
                        disablePortal
                        options={propertyManagement}
                        value={selectPropertyManagement}
                        getOptionLabel={(option) => option.propertyMgmtName}
                        onChange={(event, newValue) => {
                          if (newValue) {
                            setPropertyManagementId(newValue.propertyMgmtId);
                            setCompanySettings({
                              ...companySettings,
                              propertyManagementId: newValue.propertyMgmtId,
                            });
                          } else {
                            setSelectedPropertyManagement(null);
                            setPropertyManagementId("");
                            setCompanySettings({
                              ...companySettings,
                              propertyManagementId: "",
                            });
                          }
                        }}
                        style={{ width: "100%" }}
                        renderInput={(params) => (
                          <CustomTextfield
                            {...params}
                            required={true}
                            label={t("PROPERTY_MANAGEMENT")}
                          />
                        )}
                      />
                    </Grid>
                  )}
                  {!initialSetUp && !propertyManagementexist && (
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <SubmitButtons
                        variant="contained"
                        onClick={savePropertyManagement}
                      >
                        <Typography
                          variant="body1"
                          style={{ textTransform: "none" }}
                        >
                          {t("Submit")}
                        </Typography>
                      </SubmitButtons>
                    </Grid>
                  )}
                  {!initialSetUp && propertyManagementexist && (
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Autocomplete
                        popupIcon={<ExpandMoreIcon />}
                        disablePortal
                        options={properties}
                        value={propertId || null}
                        getOptionLabel={(option) => option.name}
                        onChange={(event, newValue) => {
                          if (newValue) {
                            setCompanySettings({
                              ...companySettings,
                              propertyId: newValue.id,
                            });
                            setPropertId(newValue);
                          } else {
                            setPropertId(null);
                            setCompanySettings({
                              ...companySettings,
                              propertyId: null,
                            });
                          }
                        }}
                        style={{ width: "100%" }}
                        renderInput={(params) => (
                          <CustomTextfield
                            {...params}
                            required={true}
                            label={t("PROPERTY")}
                          />
                        )}
                      />
                    </Grid>
                  )}
                  {!initialSetUp && propertyManagementexist && !propertyExist && (
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <SubmitButtons variant="contained" onClick={saveProperty}>
                        <Typography
                          variant="body1"
                          style={{ textTransform: "none" }}
                        >
                          {t("Submit")}
                        </Typography>
                      </SubmitButtons>
                    </Grid>
                  )}
                  {!initialSetUp && propertyManagementexist && propertyExist && (
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Stack direction="row" spacing={2}>
                        <Autocomplete
                          popupIcon={<ExpandMoreIcon />}
                          disablePortal
                          options={issueTypes}
                          getOptionLabel={(option) => option.name}
                          groupBy={(option) => option.parentId || ""}
                          value={issueTypeSelected}
                          onChange={handleIssueType}
                          style={{ width: "100%" }}
                          renderInput={(params) => (
                            <CustomTextfield
                              {...params}
                              required={true}
                              label={t("ISSUE_TYPES")}
                            />
                          )}
                          renderOption={(props, option) => (
                            <li
                              {...props}
                              style={{
                                backgroundColor: option.parentId
                                  ? "transparent"
                                  : "#f1f1f1",
                                paddingLeft: option.parentId ? "20px" : "0",
                                fontWeight: option.parentId ? "normal" : "bold",
                                color: option.parentId
                                  ? darkMode
                                    ? "#fff"
                                    : "#000"
                                  : "",
                              }}
                            >
                              {option.name}
                            </li>
                          )}
                        />
                        <Button
                          style={{
                            height: "50px",
                            backgroundColor: "lightblue",
                            color: "black",
                            borderRadius: "20px !important",
                          }}
                          onClick={handleAddIssueType}
                        >
                          {t("COMMON009")}
                        </Button>
                      </Stack>
                    </Grid>
                  )}
                </Grid>
              </Box>
            )}

            {!initialSetUp && propertyManagementexist && propertyExist && (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                style={{ display: "flex", direction: "rtl", marginTop: "10px", left: "17px" }}
              >
                <SubmitButtons variant="contained" onClick={saveSettings}>
                  <Typography variant="body1" style={{ textTransform: "none" }}>
                    {t("Submit")}
                  </Typography>
                </SubmitButtons>
              </Grid>
            )}
          </TabPanel>
        )}
        <TabPanel value="2" style={{ padding: "0px", marginTop: "45px" }}>
          <Box
            display={"flex"}
            flexDirection={"row-reverse"}
            alignItems={"center"}
          >
            <Grid style={{ display: "flex", cursor: "pointer" }}>
              <Button
                onClick={handleGenerateKey}
                size="large"
                variant="outlined"
                style={{
                  color: "#FFFFFF",
                  backgroundColor: "#F2824C",
                  border: "2px solid #F2824C",
                }}
              >
                {!noteable ? (
                  <Typography>{t("GENERATE")}</Typography>
                ) : (
                  <Typography>{t("RE-GENERATE")}</Typography>
                )}
              </Button>
              
              <Tooltip title={t("COMMON002")}>
                <Box item
                  className="refreshIcon"
                >
                  <RefreshIcon onClick={() => loadAPIKeys(paging)} />
                </Box>
              </Tooltip>
            </Grid>
          </Box>

          <div style={{ height: 300, width: "100%", marginTop: "5px" }}>
            <DataTableLatest
              columns={columns}
              rows={rows}
              page={page}
              approvals={true}
              count={totalRecords}
              rowId={(row) => row.accessKey}
              pageCount={totalPages}
              pageSize={rowsPerPage}
              handleChange={(newPage, size) => handleChange(newPage, size)}
            />
          </div>
        </TabPanel>
      </TabContext>

      {openDialog && (
        <KeyValidityDialog
          open={openDialog}
          onSubmit={handleRegenerateKeys}
          onClose={() => {
            setOpenDialog(false);
            setDiaLogBoxBlur(false);
          }}
        />
      )}
      {addIssueType && (
        <CreateIssueTypeDialog
          open={addIssueType}
          handleClose={() => {
            setAddIssueType(!addIssueType);
            setDiaLogBoxBlur(false);
          }}
          data={{
            propertyManagementId: propertyManagementId,
          }}
          handleCallBackData={handleCallbackData}
        />
      )}
    </>
  );
}

export default Integration;
